import type { CSSProperties } from "react";

import type { Column } from "../../Table.types";

/**
 * Get the common columnPinning styles for a column
 * @param column
 *
 * @returns CSSProperties
 */
export function getCommonPinningStyles<TableData extends Record<string, any>>(
  column: Column<TableData>
): CSSProperties {
  const isPinned = column.getIsPinned();
  const isLastLeftPinnedColumn =
    isPinned === "left" && column.getIsLastColumn("left");
  const isFirstRightPinnedColumn =
    isPinned === "right" && column.getIsFirstColumn("right");

  return {
    boxShadow: isLastLeftPinnedColumn
      ? "-0.25rem 0 0.25rem -0.25rem gray inset"
      : isFirstRightPinnedColumn
        ? "0.25rem 0 0.25rem -0.25rem gray inset"
        : undefined,
    left: isPinned === "left" ? `${column.getStart("left")}px` : undefined,
    right: isPinned === "right" ? `${column.getAfter("right")}px` : undefined,
    opacity: isPinned ? 0.95 : 1,
    position: isPinned ? "sticky" : "relative",
    zIndex: isPinned ? 1 : "unset"
  };
}
